// Description: Function that handle the state management of the application
// Updated: 01/10/2025
// Author: Simon Franklin

// Components and Functions for the project
import { create } from "zustand";
import { checkAuth } from "../utils/utils";
import { isAuthenticated } from "../authMiddleware";
import { ProfileGet } from "../api/aws/Profile/ProfileGet";
import AlternativeAvatar from "../assets/images/avatar-padrao.png";

// Render the store
const use123zapStore = create((set, get) => ({

    userAuthenticated: checkAuth(),
    setUserAuthenticated: (value) => set({ userAuthenticated: value }),

    loading: false,
    setLoading: (value) => set({ loading: value }),

    userInfo: {},
    setUserInfo: (value) => set({ userInfo: value }),

    userAvatar: null,
    setUserAvatar: (value) => set({ userAvatar: value }),

    planoAtual: null,
    setPlanoAtual: (value) => set({ planoAtual: value }),

    finishedRegister: null,
    setFinishedRegister: (value) => set({ finishedRegister: value }),

    initUserInfo: () => {
        const isEmpty = Object.keys(get().userInfo).length === 0;
        const userAuthenticated = get().userAuthenticated;

        if (userAuthenticated && isEmpty) {
            const { decryptedData } = isAuthenticated();
            set({ userInfo: decryptedData });
        }
    },

    loadPlanoAtual: async () => {
        const { planoAtual, userAuthenticated } = get();

        if ((!planoAtual || planoAtual === null) && userAuthenticated) {
            const response = await ProfileGet();
            set({ planoAtual: response.plan_name });
        }
    },

    loadUserAvatar: () => {
        const { userAvatar } = get();
        if (userAvatar !== null) return;

        const idToken = localStorage.getItem("idToken");
        if (!idToken) return;

        try {
            const base64Url = idToken.split('.')[1];
            const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
            const jsonPayload = decodeURIComponent(
                atob(base64)
                    .split('')
                    .map(c => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
                    .join('')
            );
            const payload = JSON.parse(jsonPayload);

            if (payload.picture) {
                set({ userAvatar: payload.picture });
            } else {
                set({ userAvatar: AlternativeAvatar });
            }
        } catch (e) {
            console.error("Erro ao decodificar token:", e);
        }
    },

    templates: [],
    setTemplates: (value) => set({ templates: value }),

    alreadyFetchTemplates: false,
    setAlreadyFetchTemplates: (value) => set({ alreadyFetchTemplates: value }),

    channels: [],
    setChannels: (value) => set({ channels: value }),

    alreadyFetchChannels: false,
    setAlreadyFetchChannels: (value) => set({ alreadyFetchChannels: value }),

    campaigns: [],
    setCampaigns: (value) => set({ campaigns: value }),

    alreadyFetchCampaigns: false,
    setAlreadyFetchCampaigns: (value) => set({ alreadyFetchCampaigns: value }),

    sheets: [],
    setSheets: (value) => set({ sheets: value }),

    alreadyFetchSheets: false,
    setAlreadyFetchSheets: (value) => set({ alreadyFetchSheets: value }),

    // ModalGraphic States
    tableColumns: [
        "Título da campanha",
        "Modelo utilizado",
        "Destinatário",
        "Data de envio",
        "Status/Entrega",
    ],
    setTableColumns: (value) => set({ tableColumns: value }),

    campaignsSummaryData: [],
    setCampaignsSummaryData: (value) => set({ campaignsSummaryData: value }),

    excelTableRows: [],
    setExcelTableRows: (value) => set({ excelTableRows: value }),

    excelTableColumns: [],
    setExcelTableColumns: (value) => set({ excelTableColumns: value }),

    showNewTable: false,
    setShowNewTable: (value) => set({ showNewTable: value }),

    receivedMessages: {
        columns: [],
        rows: []
    },
    setReceivedMessages: (value) => set({ receivedMessages: value }),

    showReceived: false,
    setShowReceived: (value) => set({ showReceived: value }),

    modalData: { label: '', date: '' },
    setModalData: (value) => set({ modalData: value }),

    integrations: [],
    setIntegrations: (value) => set({ integrations: value }),

    alreadyFetchIntegrations: false,
    setAlreadyFetchIntegrations: (value) => set({ alreadyFetchIntegrations: value }),

    registeredERPS: [],
    setRegisteredERPS: (value) => set({ registeredERPS: value }),

    alreadyFetchRegisteredERPS: false,
    setAlreadyFetchRegisteredERPS: (value) => set({ alreadyFetchRegisteredERPS: value }),

    isCollapsed: false,
    setIsCollapsed: (value) => set({ isCollapsed: value }),

    showSidebar: true,
    setShowSidebar: (value) => set({ showSidebar: value })
}))

export default use123zapStore;